import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import terminology from 'javascripts/terminology';

export class Name extends Field {
  static attributesForModel() {
    return ['name', 'path'];
  }

  get title() {
    return 'Name';
  }

  exampleContents(): FieldContentsData {
    return {
      text: `Example ${terminology(this.terminologyName.toLowerCase())}`,
      url: '',
      titleStyle: true,
    };
  }

  contentsForRecord(record): FieldContentsData {
    return {
      text: record.name,
      url: record.path,
      titleStyle: true,
      recordRef: {
        typename: record.typename,
        id: record.referenceNum || record.id,
      },
    };
  }
}
